
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  layout: 'guide',
  description: 'Learn about the matching algorithms employed by Plaid Monitor as well as the available watchlists.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Watchlists and matching algorithms' subtitle='Learn about the watchlists and matching algorithms used by Monitor' mdxType="Header" />
    <p>{`Plaid Monitor's system supports a wide variety of algorithms and languages to support common inconsistencies across both user inputs and underlying watchlist search data.`}</p>
    <h4 {...{
      "id": "supported-languages"
    }}>{`Supported languages`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Arabic`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`German`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Korean`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Spanish`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Simplified Chinese`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Greek`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Pashto`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Thai`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Traditional Chinese`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hungarian`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Persian`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Urdu`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`English`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Italian`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Portuguese`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`French`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Japanese`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Russian`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hebrew`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Burmese`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Vietnamese`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "supported-algorithms"
    }}>{`Supported algorithms`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Phonetic similarity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Jesus ↔ Heyzeus ↔ Haezoos`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Transliteration spelling differences`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Abdul Rasheed ↔ Abd al-Rashid`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Nicknames`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`William ↔ Will ↔ Bill ↔ Billy`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Missing spaces or hyphens`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`MaryEllen ↔ Mary Ellen ↔ Mary-Ellen`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Titles and honorifics`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Dr. ↔ Mr. ↔ Ph.D.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Truncated name components`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`McDonalds ↔ McDonald ↔ McD`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Missing name components`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Phillip Charles Carr ↔ Phillip Carr`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Out-of-order name components`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Diaz, Carlos Alfonzo ↔ Carlos Alfonzo Diaz`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Initials`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`J. E. Smith ↔ James Earl Smith`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Names split inconsistently across database fields`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Dick. Van Dyke ↔ Dick Van . Dyke`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Same name in multiple languages`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mao Zedong ↔ Мао Цзэдун ↔ 毛泽东 ↔ 毛澤東`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Semantically similar names`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Eagle Pharmaceuticals, Inc. ↔ Eagle Drugs, Co.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Semantically similar names across language`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Nippon Telegraph and Telephone Corporation ↔ 日本電信電話株式会社`}</td>
        </tr>
      </tbody>
    </table>
    <h5 {...{
      "id": "name-sensitivity"
    }}>{`Name sensitivity`}</h5>
    <p>{`Plaid determines a similarity score based on the result of these comparisons. Each type of matching will have a different impact on the overall similarity score, based on the importance of the discrepancy, the length and composition of the name being verified, and other variables like language. For example, "Mr. John Doe" vs. "John Doe" will receive a negligible penalty, whereas "John Paul Doe" vs "John Doe" will receive a more significant penalty.`}</p>
    <p>{`The sensitivity you select will determine the minimum similarity score required for a match. We recommend that you start with Balanced sensitivity and adjust as needed.`}</p>
    <p>{`If you are migrating from another identity verification solution and have configured similarity scores there, you can use the following table to roughly equate Plaid's sensitivity levels with similarity scores:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name sensitivity`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Minimum acceptable similarity score`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Coarse`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`70`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Balanced`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`80`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Strict`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`90`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Exact`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`99`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Note that setting the scores at a comparable level between different solutions will not yield exactly the same results, since different products use different algorithms.`}</p>
    <h4 {...{
      "id": "supported-watchlists"
    }}>{`Supported watchlists`}</h4>
    <p><strong parentName="p">{`US – Office of Foreign Assets Control`}</strong></p>
    <ul>
      <li parentName="ul">{`Specially Designated Nationals and Blocked Persons List`}</li>
      <li parentName="ul">{`Foreign Sanctions Evaders`}</li>
      <li parentName="ul">{`Non-SDN Palestinian Legislative Council List`}</li>
      <li parentName="ul">{`Sectoral Sanctions Identifications`}</li>
      <li parentName="ul">{`Non-SDN Menu-Based Sanctions`}</li>
      <li parentName="ul">{`Correspondent Account or Payable-Through Account Sanctions`}</li>
      <li parentName="ul">{`Non-SDN Chinese Military-Industrial Complex Companies List`}</li>
    </ul>
    <p><strong parentName="p">{`US – Department of Justice`}</strong></p>
    <ul>
      <li parentName="ul">{`FBI Wanted List`}</li>
    </ul>
    <p><strong parentName="p">{`US – Department of State`}</strong></p>
    <ul>
      <li parentName="ul">{`Nonproliferation Sanctions`}</li>
      <li parentName="ul">{`AECA Debarred`}</li>
      <li parentName="ul">{`Terrorist Exclusion List`}</li>
    </ul>
    <p><strong parentName="p">{`US – General Services Administration`}</strong></p>
    <ul>
      <li parentName="ul">{`System for Award Management (SAM) Exclusion List (formerly known as the Excluded Parties List System)`}</li>
    </ul>
    <p><strong parentName="p">{`Bureau of Industry and Security`}</strong></p>
    <ul>
      <li parentName="ul">{`Denied Persons List`}</li>
      <li parentName="ul">{`Unverified List`}</li>
    </ul>
    <p><strong parentName="p">{`UK – Foreign, Commonwealth & Development Office (FCDO)`}</strong></p>
    <ul>
      <li parentName="ul">{`UK Sanctions List`}</li>
    </ul>
    <p><strong parentName="p">{`EU – European External Action Service`}</strong></p>
    <ul>
      <li parentName="ul">{`Consolidated list`}</li>
    </ul>
    <p><strong parentName="p">{`AU – Department of Foreign Affairs and Trade`}</strong></p>
    <ul>
      <li parentName="ul">{`Consolidated list`}</li>
    </ul>
    <p><strong parentName="p">{`CA – Government of Canada`}</strong></p>
    <ul>
      <li parentName="ul">{`Consolidated List of Sanctions`}</li>
    </ul>
    <p><strong parentName="p">{`International`}</strong></p>
    <ul>
      <li parentName="ul">{`Interpol Red Notices for Wanted Persons List`}</li>
      <li parentName="ul">{`World Bank Listing of Ineligible Firms and Individuals`}</li>
      <li parentName="ul">{`United Nations Consolidated Sanctions`}</li>
    </ul>
    <p><strong parentName="p">{`Politically Exposed Persons`}</strong></p>
    <ul>
      <li parentName="ul">{`Politically Exposed Persons List`}</li>
      <li parentName="ul">{`State Owned Enterprise List`}</li>
      <li parentName="ul">{`CIA List of Chiefs of State and Cabinet Members`}</li>
    </ul>
    <p><strong parentName="p">{`SG - Government of Singapore`}</strong></p>
    <ul>
      <li parentName="ul">{`Terrorists and Terrorist Entities`}</li>
    </ul>
    <p><strong parentName="p">{`TR - Government of Turkey`}</strong></p>
    <ul>
      <li parentName="ul">{`Terrorist Wanted List`}</li>
      <li parentName="ul">{`Domestic Freezing Decisions`}</li>
      <li parentName="ul">{`Foreign Freezing Requests`}</li>
      <li parentName="ul">{`Weapons of Mass Destruction`}</li>
      <li parentName="ul">{`Capital Markets Board`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "supported-languages",
        level: 4,
        title: "Supported languages",
      },
{
        id: "supported-algorithms",
        level: 4,
        title: "Supported algorithms",
      },
{
        id: "supported-watchlists",
        level: 4,
        title: "Supported watchlists",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
